import { render, staticRenderFns } from "./wcnr.vue?vue&type=template&id=680e2c50&scoped=true"
import script from "./wcnr.vue?vue&type=script&lang=js"
export * from "./wcnr.vue?vue&type=script&lang=js"
import style0 from "./wcnr.vue?vue&type=style&index=0&id=680e2c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e2c50",
  null
  
)

export default component.exports